export default __webpack_public_path__ + "static/media/Facilities-CACS-18.320507d4.jpg";